/**
 * @generated SignedSource<<948624c9802badf7e25aaa957d7b8434>>
 * @relayHash d0f80aed3553bd2f5024d6e0b4d5cfd7
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 78fe4f4eea309ac8871c5e83f96016de5b3b3441b9c4396b7de568c88fb9f7c4

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { JourneyConfigurationPageQuery } from './JourneyConfigurationPageQuery.graphql';

import isValidationFGEnabled_provider from '@atlassian/jira-relay-provider/src/jira-journey-builder-improve-validation.relayprovider';
import isConditionsFGEnabled_provider from '@atlassian/jira-relay-provider/src/jsm-journey-builder-condition-smart-value.relayprovider';

const node: PreloadableConcreteRequest<JourneyConfigurationPageQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "78fe4f4eea309ac8871c5e83f96016de5b3b3441b9c4396b7de568c88fb9f7c4",
    "metadata": {},
    "name": "JourneyConfigurationPageQuery",
    "operationKind": "query",
    "text": null,
    "providedVariables": {
      "__relay_internal__pv__atlassianjirarelayprovidersrcjirajourneybuilderimprovevalidationrelayprovider": isValidationFGEnabled_provider,
      "__relay_internal__pv__atlassianjirarelayprovidersrcjsmjourneybuilderconditionsmartvaluerelayprovider": isConditionsFGEnabled_provider
    }
  }
};

export default node;
